module.exports = "<div class=\"widget-header widget-header-blue widget-header-flat\">\n\t<h4 class=\"lighter\">\n\t\t<ng-content></ng-content>\n\t</h4>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/widgets/widget/widget-header.html
// module id = 545
// module chunks = 0